export default __webpack_public_path__ + "static/media/day-1.524b0f91.jpg";